export enum AssessmentCardTypes {
  'Regular' = 'Regular',
  'Completed' = 'Completed',
  'In_progress' = 'In progress',
  'Recommended' = 'Recommended',
  'Overdue' = 'Overdue',
  'Not_started' = 'Not started',
  'HR_info' = 'HR info',
}